import { I18nEnum } from "@/entities/account/account.types"
import { memo } from "react"
import { useTranslation } from "react-i18next"

const Footer = () => {
  const { t, i18n } = useTranslation()
  const isKoreanLanguage = i18n.language.startsWith(I18nEnum.Ko)

  return (
    <div className="border-t border-border-color bg-card px-4 py-3 text-tooltip text-gray-backdrop-900">
      <div className="flex items-center justify-between">
        <div className="flex justify-center">
          <div className="flex items-center pr-6">
            <a
              href={`/legal/terms-of-use${
                isKoreanLanguage ? "" : "/en"
              }/translator`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <p className="mr-3 font-semibold">{t("login.termsOfUse")}</p>
            </a>
            <a
              href={`/legal/privacy-policy${isKoreanLanguage ? "" : "/en"}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <p className="font-semibold">{t("login.privacyPolicy")}</p>
            </a>
          </div>
          {isKoreanLanguage && (
            <div className="border-l border-border-color px-6">
              <div>
                <span className="font-semibold">(주)베링랩</span>
                <span className="mx-3">사업자등록번호: 643-81-01523</span>
                <span>대표: 문성현</span>
                <span className="mx-3">상호명: 주식회사 베링랩</span>
                <span>통신판매업 신고번호: 2034-서울관악-1655</span>
                <span className="mx-3">
                  서울특별시 영등포구 의사당대로 83, 4층 105호 (여의도동,
                  오투타워)
                </span>
              </div>
            </div>
          )}
          <div className="border-l border-border-color px-6">
            <span>
              {t("footer.contact")}
              <a
                className="underline-offset-3 underline"
                href="mailto:support@beringlab.com"
              >
                support@beringlab.com
              </a>
              {isKoreanLanguage && t("footer.contact2")}
            </span>
          </div>
        </div>
        <div>
          {!isKoreanLanguage && (
            <>
              Copyright © {new Date().getFullYear()} Bering Lab Inc. All rights
              reserved.
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default memo(Footer)
